import React from 'react';
import './Description.css';

import { FaArrowDown, FaArrowUp,FaWind} from 'react-icons/fa';
import{ BiHappy } from "react-icons/bi";
import { MdCompress, MdOutlineWaterDrop } from "react-icons/md";

const Description = ({weather, unit}) => {

    const tempUnit = unit === 'metric' ? '°C' : '°F'
    const windUnit = unit === 'metric' ? 'm/s' : 'm/h'
    const cards = [
        {
            id:1,
            icon:<FaArrowUp />,
            title:"max",
            data: weather.temp_max.toFixed(),
            unit :tempUnit,
        },

        {
            id:2,
            icon:<FaArrowDown />,
            title:"min",
            data: weather.temp_min.toFixed(),
            unit :tempUnit,
        },

        {
            id:4,
            icon:<BiHappy />,
            title:"feels like",
            data: weather.feels_like.toFixed(),
            unit :tempUnit,
          
        },

        {
            id:3,
            icon:<FaWind />,
            title:"Windspeed",
            data: weather.speed.toFixed(),
            unit :windUnit,
        },

        {
            id:5,
            icon:<MdCompress />,
            title:"pressure",
            data: weather.pressure,
            unit :"hpa",
        },

        {
            id:6,
            icon:<MdOutlineWaterDrop />,
            title:"max",
            data: weather.humidity,
            unit :"%",
        },
    ]
  return ( 
  <div className='section section__descriptions'>
    {cards.map(({id, icon, title, data, unit})=> (
    <div key={id} className='card'>
    <div className='description__card-icon'>
            { icon }
        <small>{title}</small>
        
        </div>
        <h2>{`${data} ${unit}`}</h2>
    </div>
    ))}
  </div>
  );
}

export default Description;